<script>
  import { M } from '../../external';

  export let context;

  let changeSet = {};

  export const getChangeSet = () => {
    return changeSet;
  };

  const roleOptions = [
    { value: 0, name: M.ONLY_ADMINS },
    { value: 1, name: M.ADMINS_MODERATORS },
    { value: 2, name: M.ALL_MEMBERS }
  ];

  const onContextUpdated = (partialUpdate) => {
    changeSet = { ...changeSet, ...partialUpdate };
  };
</script>

<div class="popup-widget-wrapper">
  <div class="sections-wrapper">
    <section>
      <div class="checkbox-wrapper mb-10">
        <input
          id="isModerationEnabled"
          checked={context.moderation?.approvalRequired < 2}
          on:change={(event) => {
            event.target.checked
              ? onContextUpdated({ moderation: { approvalRequired: 1 } })
              : onContextUpdated({ moderation: { approvalRequired: 2 } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="isModerationEnabled" />
        <label for="isModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
          >{M.SOCIAL_REQUIRE_APPROVAL}
        <p>{M.REQUIRED_APPROVAL_COMMENT_DESC}</p></label>
      </div>
    </section>
    <section class="mt-5 mb-5">
      <div class="info">
        <h4>{M.SOCIAL_WHO_CAN_REPLY}</h4>
      </div>
      <select
        class="col20 f-left"
        bind:value={context.commentModeration.writePermission}
        on:change={() => {
          onContextUpdated({
            commentModeration: { writePermission: context.commentModeration.writePermission }
          });
        }}>
        {#each roleOptions as option}
          <option value={option.value}>{option.name}</option>
        {/each}
      </select>
    </section>
    <section>
      <div class="checkbox-wrapper">
        <input
          id="commentIsModerationEnabled"
          checked={context.commentModeration.approvalRequired < 2}
          on:change={(event) => {
            event.target.checked
              ? onContextUpdated({ commentModeration: { approvalRequired: 1 } })
              : onContextUpdated({ commentModeration: { approvalRequired: 2 } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="commentIsModerationEnabled" />
        <label for="commentIsModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
          >{M.SOCIAL_REQUIRE_REPLY_APPROVAL}</label>
      </div>
    </section>
    <section>
      <div class="checkbox-wrapper">
        <input
          id="allowImages"
          bind:checked={context.extra.allowImages}
          on:change={() => {
            onContextUpdated({ extra: { allowImages: context.extra.allowImages } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="allowImages" />
        <label for="allowImages" class="css-label button-tooltip" data-original-title="" title=""
          >{M.ALLOW_IMAGES}</label>
      </div>
    </section>
    <section>
      <div class="checkbox-wrapper">
        <input
          id="allowMentions"
          bind:checked={context.extra.allowMentions}
          on:change={() => {
            onContextUpdated({ extra: { allowMentions: context.extra.allowMentions } });
          }}
          class="css-checkbox"
          type="checkbox"
          name="allowMentions" />
        <label for="allowMentions" class="css-label button-tooltip" data-original-title="" title=""
        >{M.ALLOW_MENTIONS}</label>
      </div>
    </section>
  </div>
</div>
